import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import SvgIcon from "../../../../parts/SvgIcon";
import { PROGRESS_VIEWS } from "./views";

// Horizontal tab nav for the five Progress views. Controlled — owns no
// state; the active id and the change handler come from the parent.
const ViewSwitch = ({ activeView, onChange }) => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div role="tablist" className="np-view-switch">
      {PROGRESS_VIEWS.map(({ id, icon }) => (
        <button
          key={id}
          aria-current={activeView === id ? "page" : undefined}
          onClick={() => onChange(id)}
        >
          <SvgIcon src={icon} useCurrentColor classNames="np-view-switch__icon" />
          <span>{t(`nutritionPage.progress.viewSwitch.${id}`)}</span>
        </button>
      ))}
    </div>
  );
};

ViewSwitch.propTypes = {
  activeView: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ViewSwitch;
